import { Switch } from "@/components/ui/switch";
import SelectCategory from "components/Dropdown/SelectCategory";
import SelectCurrenciesList from "components/Dropdown/SelectCurrenciesList";
import SelectCurrency from "components/Dropdown/SelectCurrency";
import SelectDaysNumber from "components/Dropdown/SelectDaysNumber";
import SelectInstrumentsBase from "components/Dropdown/SelectInstrumentsBase";
import SelectListMetals from "components/Dropdown/SelectListMetals";
import SelectLocation from "components/Dropdown/SelectLocation";
import SelectMetal from "components/Dropdown/SelectMetal";
import SelectNewsCategory from "components/Dropdown/SelectNewsCategory";
import SelectPMBM from "components/Dropdown/SelectPMBM";
import SelectTickers from "components/Dropdown/SelectTickers";
import SelectTimeFrame from "components/Dropdown/SelectTimeFrame";
import SelectUnit from "components/Dropdown/SelectUnit";
import SelectView from "components/Dropdown/SelectView";
import { VisualizationType } from "components/types";
import { config } from "process";

interface SettingsProps {
  isContainerChecked: boolean;
  isTransparentChecked: boolean;
  widthValue: number;
  theme: 'light' | 'dark';
  defaultWidth: string;
  defaultItem?: DefaultItem | undefined;
  isReset?: boolean;
  handleChange: (e: any) => void;
  handleContainerChecked: (e: any) => void;
  handleThemeChange: (e: any) => void;
  handleTrasparentChecked: (e: any) => void;
  handleBlur: (limit: number) => void;
  updateDefaultItem?: (defaultItem: DefaultItem | undefined) => void;
  selectedVisualization?: VisualizationTypeDefault;
  setSelectedVisualization?: (value: VisualizationTypeDefault) => void;
  selectedCategory?: DefaultCategories;
  setSelectedCategory?: (value: DefaultCategories) => void;
  selectedUnit?: DefaultUnits;
  setSelectedUnit?: (value: DefaultUnits) => void;
  showChange?: boolean;
  setShowChange?: (value: boolean) => void;
  selectedMetal?: DefaultMetals;
  setSelectedMetal?: (value: DefaultMetals) => void;
  selectTimeFrame?: DefaultTimeFrame;
  setSelectedTimeFrame?: (value: DefaultTimeFrame) => void;
  selectedNews?: DefaultNews;
  setSelectedNews?: (value: DefaultNews) => void;
  selectedCurrency?: DefaultCurrency;
  setSelectedCurrency?: (value: DefaultCurrency) => void;
  listTimeFrames?: DefaultTimeFrame[];
  selectedTicker?: DefaultTicker[];
  setSelectedTicker?: (value: DefaultTicker[]) => void;
  selectedCurrencyList?: DefaultCurrency[];
  setSelectedCurrencyList?: (value: DefaultCurrency[]) => void;
  selectedAllMetals?: DefaultMetals;
  setSelectedAllMetals?: (value: DefaultMetals) => void;
  selectedDaysNumber?: DefaultDaysNumber;
  setSelectedDaysNumber?: (value: DefaultDaysNumber) => void;
  selectedLocation?: DefaultLocation[];
  setSelectedLocation?: (value: DefaultLocation[]) => void;
  selectedListMetals?: DefaultMetalsList[];
  setSelectedListMetals?: (value: DefaultMetalsList[]) => void;
  labelChange?: string;
  listMetals?: DefaultMetals[];
  limitWidth?: number;
  config?: WidgetConfig;
}

function SettingsWidget({
  isContainerChecked,
  isTransparentChecked,
  widthValue,
  theme,
  handleChange,
  handleContainerChecked,
  handleThemeChange,
  handleTrasparentChecked,
  defaultWidth,
  defaultItem, 
  limitWidth, 
  updateDefaultItem, 
  selectedVisualization,
  setSelectedVisualization,  
  selectedCategory, 
  setSelectedCategory, 
  selectedUnit,
  setSelectedUnit,
  selectTimeFrame, 
  setSelectedTimeFrame, 
  listTimeFrames, 
  selectedNews,
  setSelectedNews,
  selectedCurrency, 
  setSelectedCurrency, 
  selectedTicker, 
  setSelectedTicker, 
  selectedCurrencyList, 
  setSelectedCurrencyList,
  selectedAllMetals, 
  setSelectedAllMetals,
  selectedDaysNumber,
  setSelectedDaysNumber,
  selectedLocation,
  setSelectedLocation,
  selectedListMetals,
  setSelectedListMetals,
  labelChange, 
  isReset, 
  config, 
  handleBlur, 
  selectedMetal,
  setSelectedMetal,
  listMetals, 
  showChange,
  setShowChange,
}: SettingsProps) {
  return (
    <div className='pt-[40px] w-full space-y-2'>
      <div className='text-[20px] font-semibold '>Settings</div>
      <div className='flex items-center w-full pt-2'>
        <div className='w-1/4 lg:w-1/3 text-[14px]'>Width <span className="text-[13px]  opacity-90">{`(min - ${limitWidth || 300}px)`}</span></div>
        <div className='flex space-x-4'>
          <input
            disabled={isContainerChecked}
            type='text'
            value={widthValue}
            onBlur={() => handleBlur(limitWidth || 300)}
            placeholder={defaultWidth}
            onChange={handleChange}
            className='border outline-none px-2 text-[14px] h-[30px] w-[100px]'
          />
          <div className='flex items-center'>
            <label className='cursor-pointer flex items-center text-[14px]'>
              <input
                type='checkbox'
                checked={isContainerChecked}
                onChange={handleContainerChecked}
                className='mr-1 h-[15px] w-[15px]'
              />
              Use container size
            </label>
          </div>
        </div>
      </div>
      <div className='flex items-center'>
        <div className='w-1/4 lg:w-1/3 text-[14px]'>Theme</div>
        <div className='flex items-center space-x-2'>
          <select
            id='theme-select'
            value={theme}
            onChange={handleThemeChange}
            className={`
          text-gray-700 px-4 text-[14px] h-[35px] border outline-none transition-colors duration-300
          dark:bg-gray-700 dark:text-gray-300 focus:outline-none grow w-[200px] lg:w-[300px]
        `}
          >
            <option value='light'>Light</option>
            <option value='dark'>Dark</option>
          </select>
        </div>
      </div>
      <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Transparent background</div>
          <input
            disabled={theme === 'dark'}
            type='checkbox'
            checked={isTransparentChecked}
            onChange={handleTrasparentChecked}
            className='mr-1 h-[15px] w-[15px] cursor-pointer'
          />
        </label>
      </div>
      {updateDefaultItem && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Default Item</div>
          <SelectInstrumentsBase defaultValue={config?.defaultItem ?? undefined} isReset={isReset} handleChange={(e:any) => {
            updateDefaultItem(e?.name)
          }}/>
        </label>
      </div>}

      {selectedVisualization && setSelectedVisualization && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Default View</div>
          <SelectView selectedInstrument={defaultItem} selectedVisualization={selectedVisualization} setSelectedVisualization={setSelectedVisualization}/>
        </label>
      </div>}

      {selectedCategory && setSelectedCategory && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Default Category</div>
          <SelectCategory selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory}/>
        </label>
      </div>}

       {setShowChange && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>{labelChange}</div>
          <Switch id="show-change" checked={showChange} onCheckedChange={setShowChange} /> 
        </label>
       </div>}

      {selectedUnit && setSelectedUnit && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Default Weight</div>
          <SelectUnit selectedUnit={selectedUnit} setSelectedUnit={setSelectedUnit}/>
        </label>
       </div>}

       {selectedMetal && setSelectedMetal && listMetals && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Default Metal</div>
          <SelectMetal selectedMetal={selectedMetal} setSelectedMetal={setSelectedMetal} listMetals={listMetals}/>
        </label>
       </div>}

      {selectTimeFrame && setSelectedTimeFrame && listTimeFrames && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Default Time</div>
          <SelectTimeFrame selectTimeFrame={selectTimeFrame} setSelectTimeFrame={setSelectedTimeFrame} listTimeFrames={listTimeFrames}/>
        </label>
       </div>}

       {selectedNews && setSelectedNews && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Default Story</div>
          <SelectNewsCategory selectedNews={selectedNews} setSelectedNews={setSelectedNews}/>
        </label>
       </div>}

       {selectedCurrency && setSelectedCurrency && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Default Currency</div>
           <SelectCurrency selectedCurrency={selectedCurrency} setSelectedCurrency={setSelectedCurrency}/>
        </label>
       </div>}

       {selectedAllMetals && setSelectedAllMetals && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Default Metal</div>
           <SelectPMBM selectedAllMetals={selectedAllMetals} setSelectedAllMetals={setSelectedAllMetals}/>
        </label>
       </div>}

       {selectedTicker && setSelectedTicker && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/2 lg:w-1/3 text-[14px]'>Items List <span className="text-[13px]  opacity-90">{'(min - 2)'}</span></div>
           <SelectTickers selectedTicker={selectedTicker} setSelectedTicker={setSelectedTicker}/>
        </label>
       </div>}
       
       {selectedCurrencyList && setSelectedCurrencyList && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/3 lg:w-1/3 text-[14px]'>Currencies List <span className="text-[13px]  opacity-90">{'(min - 1)'}</span></div>
           <SelectCurrenciesList selectedCurrencyList={selectedCurrencyList} setSelectedCurrencyList={setSelectedCurrencyList}/>
        </label>
       </div>}

       {selectedDaysNumber && setSelectedDaysNumber && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/3 lg:w-1/3 text-[14px]'>Number of days</div>
           <SelectDaysNumber selectedDaysNumber={selectedDaysNumber} setSelectedDaysNumber={setSelectedDaysNumber}/>
        </label>
       </div>}

       {selectedLocation && setSelectedLocation && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/3 lg:w-1/3 text-[14px]'>Locations <span className="text-[13px]  opacity-90">{'(min - 1)'}</span></div>
           <SelectLocation selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/>
        </label>
       </div>}

       {selectedListMetals && setSelectedListMetals && <div className='flex items-center'>
        <label className='w-full flex items-center'>
          <div className='w-1/3 lg:w-1/3 text-[14px]'>Metals <span className="text-[13px]  opacity-90">{'(min - 1)'}</span></div>
           <SelectListMetals selectedListMetals={selectedListMetals} setSelectedListMetals={setSelectedListMetals}/>
        </label>
       </div>}


    </div>
  );
}

export default SettingsWidget;
